var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Box',{staticClass:"integrations__upgrade-alert"},[_c('span',[_vm._v(" "+_vm._s(_vm.message)+" ")]),_c('DarkContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }